import { COOKIE_POLICY_NAME } from 'components/CookiePolicy/CookiePolicy'

export function sendAdriverEvent(sz, customParams = {}) {
  const cookieExists = getCookie(COOKIE_POLICY_NAME) === '1'
  if (!cookieExists) return

  const eventParams = {
    sid: 229634,
    bt: 62,
    sz: sz,
    loc: encodeURIComponent(window.location.href),
    tail256: document.referrer || 'unknown',
  }

  Object.assign(eventParams, customParams)

  function serializeParams(params, separator = '&', assigner = '=') {
    const result = []
    for (const key in params) {
      // eslint-disable-next-line no-prototype-builtins
      if (params.hasOwnProperty(key)) {
        result.push(`${key}${assigner}${encodeURIComponent(params[key])}`)
      }
    }
    return result.join(separator)
  }

  function getCookie(name) {
    const match = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`)
    return match ? decodeURIComponent(match[2]) : null
  }

  const cookies = {
    adrcid: getCookie('adrcid'),
    _ga: getCookie('_ga'),
    _ym_uid: getCookie('_ym_uid'),
  }

  if (cookies.adrcid) eventParams.cid = cookies.adrcid
  if (cookies._ga) eventParams.gid1 = encodeURIComponent(cookies._ga)
  if (cookies._ym_uid) eventParams.yid1 = encodeURIComponent(cookies._ym_uid)

  const random = Math.floor(1e6 * Math.random())

  const url = `https://ad.adriver.ru/cgi-bin/rle.cgi?${serializeParams(eventParams)}&rnd=${random}`

  const img = new Image()
  img.style.position = 'absolute'
  img.style.display = 'none'
  img.style.width = img.style.height = '0px'
  img.setAttribute('referrerpolicy', 'no-referrer-when-downgrade')
  img.src = url

  document.body.appendChild(img)
}
